import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { PaymentProvider } from "@@/shared/payments/payment-providers";
import type { Target } from "@@/shared/target";
import type { UUID } from "@@/shared/uuid";
import type { Version } from "@@/shared/version";

type PaymentPubSubEventData<
    EventData extends Record<string, unknown> = Record<string, unknown>,
> = {
    paymentUUID: UUID;
    paymentFor: Target[];
    paymentProvider: PaymentProvider;
    createdAt: IsoAndUnixTimestamp;
    requestedAmount: number;
    paidAmount: number;
    refundedAmount: number;
    version: Version;
} & (undefined extends EventData ? unknown : EventData);

const createPaymentPubSubEventData = <
    EventData extends Record<string, unknown> = Record<string, unknown>,
>(params: {
    eventData: PaymentPubSubEventData<EventData>;
}): PaymentPubSubEventData<EventData> => {
    return params.eventData;
};

export { createPaymentPubSubEventData };
export type {
    PaymentPubSubEventData as PaymentPubSubBaseData,
    PaymentPubSubEventData,
};
